// Auth
import { msalInstance } from './config/azureConfig';
import ReactDOM from "react-dom";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionType } from '@azure/msal-browser';
import ReduxApp from './reduxApp';
const DO_NOT_LOGIN = false;

msalInstance.handleRedirectPromise().then((response) => {
    if (response !== null && response.account !== null) {
        msalInstance.setActiveAccount(response.account);
    }
}).catch((error) => {
    console.error("Login redirect failed: ", error);
});

ReactDOM.render(
  <MsalProvider instance={msalInstance}>
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={{ scopes: [`${process.env.REACT_APP_CLIENT_ID}/.default`] }}
    >
      <ReduxApp />
    </MsalAuthenticationTemplate>
  </MsalProvider>,
  document.getElementById("root")
);
